
import { z } from 'zod';
import { secureValidationSchemas } from '@/utils/security/validation';

export const updateCandidateBasicInfoSchema = z.object({
  first_name: secureValidationSchemas.name.optional(),
  last_name: secureValidationSchemas.name.optional(),
});

export type UpdateCandidateBasicInfoSchema = z.infer<typeof updateCandidateBasicInfoSchema>;
